<template>
  <div id="header" class="bg-1">
    <div
      class="header header-mobile text-light flex-column align-left"
      v-if="this.windowWidth < 900"
      :style="navMobile ? 'left: 0;' : ''"
    >
      <div v-for="(item, index) in routes" :key="index" class="subtitle-1">
        <div class="flex align-center" @click="toRoute(item)">
          {{ item.name }}
          <svg
            v-if="item.submenu"
            width="12" height="14"
            viewBox="0 4 20 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="!item.closed ? 'transform: rotate(180deg)' : ''"
          >
            <path d="M1 1L9 9L17 1" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div v-if="item.submenu" v-show="!item.closed" class="submenu-item flex-column align-left">
          <div
            v-for="(sub, index) in item.submenu"
            :key="index"
            class="subtitle-5"
            @click="toSubRoute(item, sub)"
          >
            {{ sub.text }}
          </div>
          <div
            v-if="item.name === 'Produtos'"
            class="subtitle-5"
            @click="toRoute(routeCatalogos)"
          >
            Catálogos
          </div>
        </div>
      </div>
      <div class="subtitle-1"><a href="https://blogdatopazio.blogspot.com/" style="color: #fafafa" target="_blank">Blog</a></div>
      <div class="subtitle-1"><a href="/area-dos-representantes" style="color: #fafafa">
        <img :src="require(`@/assets/focco.png`)" width="100">
      </a></div>
    </div>
    <div class="flex align-center justify-space-between header-fixed">
      <a href="/">
        <div class="logo">
          <img src="@/assets/logo.png" height="42" id="logo-icon"/>
        </div>
      </a>
      <div class="header flex align-center" v-if="this.windowWidth > 900">
        <div class="nav flex">
          <router-link
            v-for="route in routes"
            :key="route.name"
            :to="route.nameRoute == 'Blog' ? { name: route.nameRoute } : { path: route.route }"
            :target="route.nameRoute == 'Blog' ? '_blank' : '_self'"
            class="navbar text-light body-3 flex-column justify-space-between align-center"
          >
            {{ route.name }}
            <ul type="none" class="submenu flex-column" v-if="route.submenu">
              <li v-for="(item, index) in route.submenu" :key="index">
                <router-link
                  v-if="route.nameRoute == 'Products'"
                  :to="{ name: route.nameRoute, params: { categoria: item.route, title: item.text } }"
                  class="text-light">
                  {{ item.text }}
                </router-link>
                <router-link v-else :to="{ name: item.nameRoute }" class="text-light">
                  {{ item.text }}
                </router-link>
              </li>
              <li v-if="route.nameRoute == 'Products'">
                <router-link
                  class="text-light"
                  :to="routeCatalogos.route"
                >
                  Catálogos
                </router-link>
              </li>
            </ul>
          </router-link>
          <a href="https://blogdatopazio.blogspot.com/" target="_blank" class="text-light body-3">Blog</a>
          <a href="/area-dos-representantes" class="text-light body-3">
            <img :src="require(`@/assets/focco.png`)" width="80">
          </a>
        </div>
      </div>
      <ToggleAnimated v-else :check-change="navMobile" @check-toggle="checkChange"/>
<!--      <div class="menu-hamburguer" @click="navMobile = true" v-else>-->
<!--        <svg width="34" height="30" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path d="M0 10H14V8H0V10ZM0 0V2H14V0H0ZM0 6H14V4H0V6Z" fill="#FAFAFA"/>-->
<!--        </svg>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import ToggleAnimated from './ToggleAnimated'

export default {
  name: 'Header',
  components: {
    ToggleAnimated
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      scrollY: window.scrollY,
      navMobile: false,
      routeCatalogos: { name: 'Catálogos', route: '/catalogos', nameRoute: 'Catalogs' },
      routes: [
        { name: 'Início', route: '/', nameRoute: 'Home' },
        {
          name: 'O Grupo',
          nameRoute: 'About',
          route: '/o-grupo',
          submenu: [
            { text: 'Nossa História', route: 'nossa-historia', nameRoute: 'OurStory' },
            { text: 'A Topázio', route: 'a-topazio', nameRoute: 'TheTopazio' }
          ],
          closed: true
        },
        {
          name: 'Produtos',
          nameRoute: 'Products',
          route: '/produtos',
          submenu: [
            { text: 'Colchões', route: 'colchoes' },
            { text: 'Estofados', route: 'estofados' },
            { text: 'Roupeiros', route: 'roupeiros' },
            { text: 'Cozinhas', route: 'cozinhas' }
          ],
          closed: true
        },
        { name: 'Onde Comprar', nameRoute: 'WhereBuy', route: '/onde-comprar' },
        {
          name: 'Para Lojistas',
          route: '/lojistas',
          nameRoute: 'Logisticians',
          submenu: [
            { text: 'Ser um afiliado', route: 'ser-um-afiliado', nameRoute: 'Affiliate' },
            { text: 'Representantes', route: 'representantes', nameRoute: 'Representatives' }
          ],
          closed: true
        },
        { name: 'Fale Conosco', route: '/fale-conosco', nameRoute: 'ContactUs' }
      ]
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  },
  methods: {
    checkChange (payload) {
      this.navMobile = payload.value
    },
    toRoute (item) {
      const index = this.routes.findIndex(r => r.name === item.name)
      if (item.submenu) {
        this.routes[index].closed = !this.routes[index].closed
      } else if (this.$route.path !== item.route) {
        this.$router.push({ path: item.route })
        this.navMobile = false
      }
    },
    toSubRoute (item, sub) {
      if (item.nameRoute === 'Products') {
        this.$router.push({ name: item.nameRoute, params: { categoria: sub.route, title: sub.text } })
        this.navMobile = false
      } else {
        this.$router.push({ name: sub.nameRoute })
        this.navMobile = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/colors';
#header {
  .logo img:hover {
    filter: brightness(100);
  }
  .header {
    padding: 12px 30px;
  }
  .header-fixed {
    padding: 7px 20px;
  }
  .header-mobile {
    height: 100vh;
    background: rgba(0, 82, 69, 0.97);
    width: 65vw;
    position: absolute;
    left: -100vw;
    transition: all .4s ease;
    gap: 20px;
    .subtitle-1:nth-child(1) {
      margin-top: 30px;
    }
    svg {
      margin: 4px 0 0 6px;
      transition: all .4s ease;
    }
    .submenu-item {
      margin: 6px 0 0 15px;
      gap: 6px;
    }
  }
  .nav {
    a {
      line-height: 22px;
      opacity: .6;
      border: none;
      max-height: 23px;
      margin-left: 20px;
    }
    a:after {
      content: '';
      opacity: 0;
      background: map-get($mainColors , 'light' );
      height: 1px;
      width: 110%;
      transition: all .3s ease-in-out;
    }
    a:hover {
      color: map-get($mainColors , 'light' );
      opacity: 1;
    }
    a.router-link-exact-active {
      color: map-get($mainColors , 'light' );
      opacity: 1;
      border: none;
    }
    a.router-link-exact-active:after {
      opacity: 1;
    }
    .navbar {
      position: relative;
      transition: all .3s ease;
      .submenu {
        background-color: rgba(60, 60, 60, 0.71);
        border-radius: 5px;
        top: 10px;
        left: 0;
        display: none;
        position: absolute;
        text-align: left;
        min-width: 150%;
        padding-top: 5px;
        padding-bottom: 5px;
        li a {
          margin-left: -50px;
          padding: 0 20px;
          opacity: 0.6;
          transition: all .3s ease;
        }
        a:hover {
          opacity: 1;
        }
      }
    }
    .navbar:hover > .submenu {
      display: block;
    }
  }
  @media screen and (max-width: 525px) {
    .header {
      padding: 12px 20px;
    }
  }
}
</style>